export default function BlueButton({ children, className = "", onClick }) {
  return (
    <button
      onClick={onClick}
      className={`rounded-xl px-3 py-2 text-sm font-semibold text-white ${className}`}
      style={{ backgroundColor: "#0B5ED7" }}
    >
      {children}
    </button>
  );
}